import { AuthService } from '@/auth/service/auth.service';
import { CompleteUserData } from '@/interfaces/my-profile/my-profile';
import { Person } from '@/interfaces/person';
import { MyProfileService } from '@/services/my-profile/my-profile.service';
import { BoxColors } from '@/shared/person-card/person-card.component';
import { StoreState } from '@/store';
import { getCurrentUserData } from '@/store/login/selectors';
import { Component, OnInit } from '@angular/core';
import { FormControl } from '@angular/forms';
import { ActivatedRoute, Router, NavigationEnd } from '@angular/router';
import { Store } from '@ngrx/store';
import { map, delay } from 'rxjs/operators';
import { combineLatest } from 'rxjs';
import { LoginResponse } from '@/auth/interface/auth.interface';

type View = 'requests' | 'licenses' | 'infractions' | 'verification';

@Component({
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.css'],
})
export class HomeComponent implements OnInit {
  currentViewControl: FormControl = new FormControl('');
  availableViews: View[] = [];
  currentView: View;

  completeUserData: Partial<CompleteUserData> = {};
  personBoxColor: BoxColors = BoxColors.BROWN_GREY;
  usingAspect: 'MY_PROFILE' = 'MY_PROFILE';
  userData?: Person;
  sendedIdToShow: number = 0;

  constructor(
    private router: Router,
    private route: ActivatedRoute,
    private auth: AuthService,
    private store: Store<StoreState>,
    private myProfileService: MyProfileService,
  ) {
    this.currentView = <View>this.router.url.split('/').reverse()[0];
    this.setCurrentView(this.currentView);
    this.drawComponents();

    const userData$ = getCurrentUserData(this.store);
    const routeChangeAndUserData$ = combineLatest(this.router.events, userData$);

    userData$.subscribe({
      next: (userData) => {
        this.userData = userData;
        this.getCompleteUserData(userData.mdmid);

        this.currentView = this.router.url.split('/').reverse()[0] as View;
        this.setCurrentView(this.currentView);
        this.drawComponents();
      },
    });

    routeChangeAndUserData$.subscribe({
      next: ([val, userData]: [any, LoginResponse]) => {
        const routeEventChange = <NavigationEnd>val;
        if (routeEventChange.url) {
          this.setCurrentView(routeEventChange.url);
          this.drawComponents();
        }
        if (!this.userData && !this.completeUserData) {
          this.getCompleteUserData(userData.mdmid);
          this.userData = userData;
        }
      },
    });

    this.currentViewControl.valueChanges.subscribe((newView) => {
      if (newView !== this.currentView) {
        this.currentView = newView;
        this.router.navigateByUrl(`/verification/${newView}`);
      }
    });
  }

  ngOnInit(): void {
    this.showDetailFromDashboard();
  }

  showDetailFromDashboard() {
    this.route.paramMap
      .pipe(map(() => window.history.state))
      .subscribe({
        next: (val) => {
          if (val.requestNumberToShow) {
            this.sendedIdToShow = val.requestNumberToShow;
          }
        },
        error: () => {
        },
      });
  }

  getCompleteUserData(userId: string) {
    this.myProfileService.getFullUserData(userId)
      .subscribe(
        (userData) => {
          this.completeUserData = userData;
        },
        () => {
          this.completeUserData = {};
        },
      );
  }

  setCurrentView(newUrl?: string) {
    if (newUrl) {
      if (newUrl !== this.currentView) {
        if (this.currentView === 'verification') {
          if (this.availableViews.length === 0) {
            this.router.navigateByUrl('/');
          }
          this.router.navigateByUrl(`/verification/${this.availableViews[0]}`);
        }
        if (newUrl.split('/').reverse()[1] === 'verification') {
          const newView = newUrl.split('/').reverse()[0];
          this.currentViewControl.patchValue(newView);
        }
      }
      if (newUrl !== this.currentViewControl.value) {
        if (newUrl === 'licenses' || newUrl === 'infractions' || newUrl === 'requests') {
          this.currentViewControl.patchValue(newUrl);
        }
      }
    }
  }

  drawComponents() {
    const availableViews: View[] = [];
    if (this.auth.userHavePrivilege('VERIFICATION_MY_PROFILE VIEW_LICENCE_STATUS')) {
      availableViews.push('licenses');
    }
    if (this.auth.userHavePrivilege('VERIFICATION_MY_PROFILE VIEW_INFRINGEMENT_STATUS')) {
      availableViews.push('infractions');
    }
    if (this.auth.userHavePrivilege('VERIFICATION_MY_PROFILE VIEW_REQUEST_STATUS')) {
      availableViews.push('requests');
    }
    this.availableViews = availableViews;
  }

}
